import { useEffect } from "react";
import SortableTree from "react-sortable-tree";
import CustomNodeContentRenderer from "../layerTree/CustomNodeContentRenderer";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ServicePreviewComponent from "./servicePreviewComponent";
import LayerPreviewComponent from "./layerPreviewComponent";
import { key, trans } from "../../lib/utils";
import { useState } from "react";
import CSWPreviewComponent from "./CSWPreviewComponent";

function RegisteredLayerTree(props) {
  const layerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );

  const layers = useSelector(
    (state) => store.getState().registeredLayerTree.layers
  );

  const sources = useSelector((state) => store.getState().sources);

  const [searchQuery, setSearchQuery] = useState(null);

  const customSearchMethod = ({ node, searchQuery }) => {
    if (layers[node.id] && searchQuery && window["map"]) {
      return (
        layers[node.id]?.title
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1 ||
        layers[node.id]?.name
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    }
    return true;
  };

  useEffect(() => {}, []);

  return (
    <div>
      <div className="p-2">
        <div className="text-end">
          <span
            role="button"
            className="text-link small p-2"
            onClick={() => {
              window["secondaryModal"].setState({
                show: true,
                size: "default",
                title: "New group",
                body: (
                  <div className="p-2">
                    <input
                      type="text"
                      id="group-title-id"
                      className="form-control"
                      placeholder={trans("Type group title")}
                    ></input>
                  </div>
                ),
                footer: [
                  <button
                    className="btn btn-sm btn-link border"
                    onClick={() => {
                      window["secondaryModal"].setState({ show: false });
                    }}
                  >
                    {trans("Cancel")}
                  </button>,
                  <button
                    className="btn btn-sm btn-secondary text-white"
                    onClick={() => {
                      store.dispatch({
                        type: "registeredLayerTree/group/add",
                        payload: {
                          id: key(),
                          title:
                            document.getElementById("group-title-id").value,
                        },
                      });

                      window["secondaryModal"].setState({ show: false });
                    }}
                  >
                    {trans("Create group")}
                  </button>,
                ],
              });
            }}
          >
            <i className="fas fa-plus me-1 small"></i>
            {trans("Add group")}
          </span>
        </div>
        <input
          type="text"
          className="form-control form-control-sm mt-2"
          placeholder={trans("Search layers...")}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
        ></input>
      </div>

      <PerfectScrollbar
        style={{ maxHeight: "calc(100vh - 30rem)" }}
        className="p-2"
      >
        <SortableTree
          treeData={layerTree}
          isVirtualized={false}
          onMoveNode={(args) => {}}
          onChange={(_treeData) => {
            store.dispatch({
              type: "registeredLayerTree/state/tree/update",
              payload: _treeData,
            });
          }}
          searchQuery={searchQuery}
          searchMethod={customSearchMethod}
          nodeContentRenderer={CustomNodeContentRenderer}
          generateNodeProps={({ node, path, treeIndex }) => ({
            more: () => {
              return null;
            },

            title: () => {
              let title = node.title;

              switch (node.type) {
                case "layer":
                  title = layers[node.id]
                    ? layers[node.id].title
                    : node.title
                    ? node.title
                    : node.layer.name;
                  break;

                case "service":
                  title = sources[node.id]
                    ? sources[node.id].title
                    : node.title;
                  break;
              }

              return (
                <div
                  className="d-flex mt-1 "
                  style={{
                    alignItems: "flex-start",
                  }}
                >
                  <span
                    className="small d-block ms-2 pe-1"
                    role="button"
                    onClick={() => {
                      switch (node.type) {
                        case "layer":
                          props.setContent(
                            <LayerPreviewComponent
                              key={key()}
                              layer={layers[node.id]}
                            ></LayerPreviewComponent>
                          );
                          break;

                        case "service":
                          if (sources[node.id].type === "CSW") {
                            props.setContent(
                              <CSWPreviewComponent
                                key={key()}
                                source={node.source}
                              ></CSWPreviewComponent>
                            );
                          } else {
                            props.setContent(
                              <ServicePreviewComponent
                                key={key()}
                                source={node.source}
                              ></ServicePreviewComponent>
                            );
                          }
                          break;
                      }
                    }}
                  >
                    {title}
                  </span>
                </div>
              );
            },
          })}
        ></SortableTree>
      </PerfectScrollbar>
    </div>
  );
}

export default RegisteredLayerTree;
